
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: 'app',
components: {
XHeader
},
data() {
return {
showRoutersName: ['chooseDepartment'],
showHeader: false,
title: '',
showBack: false,
showBackHome: false
};
},
created() {
var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
var width = w > h ? h : w;
width = width > 750 ? 750 : width;
var fz = ~~((width * 100000) / 75) / 10000;
document.getElementsByTagName('html')[0].style.cssText = 'font-size: ' + fz + 'px !important';
var realfz = ~~(+window.getComputedStyle(document.getElementsByTagName('html')[0]).fontSize.replace('px', '') * 10000) / 10000;
if (fz !== realfz) {
document.getElementsByTagName('html')[0].style.cssText = 'font-size: ' + fz * (fz / realfz) + 'px !important';
}

this.saveStore()
},
methods: {
saveStore() {

if (sessionStorage.getItem("store")) {
this.$store.replaceState(
Object.assign(
{},
this.$store.state,
JSON.parse(sessionStorage.getItem("store"))
)
);
}

window.addEventListener("beforeunload", () => {
sessionStorage.setItem("store", JSON.stringify(this.$store.state));
});
}
},
watch: {
$route: {
handler(r) {
this.showHeader = !r.path.includes('home') && r.path !== '/';
this.title = r.meta.title;
this.showBack = history.length > 0;
this.showBackHome = r.query.backHome; 
},
immediate: true
}
}
};



// WEBPACK FOOTER //
// ./src/App.vue